import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './index.css';
import heroBg from '../assests/SustainabilityImages/sustain_world.jpeg';
import vennDiagram from '../assests/SustainabilityImages/Venndiagram.png';

import section2img from "../assests/HomeImg/section2-img.svg";

import EnvironmentalIcon from '../assests/SustainabilityImages/EnvironmentalIcon.svg';
import SocialIcon from '../assests/SustainabilityImages/SocialIcon.svg';
import GovernanceIcon from '../assests/SustainabilityImages/GovernanceIcon.svg';

import SolarPVInstallation from '../assests/SustainabilityImages/SolarPVInstallation.png';
import ZeroLiquidDischarge from '../assests/SustainabilityImages/ZeroLiquidDischarge.png';
import CommittedNetZeroBgImage from '../assests/SustainabilityImages/CommittedNetZeroBgImage.png';

import Certified from "../assests/SustainabilityImages/health.svg";
import Chemical from "../assests/SustainabilityImages/chemical.svg";
import ProcessSafety from "../assests/SustainabilityImages/process .svg";
import Amria from "../assests/SustainabilityImages/AMRIA.svg";
import Suppliers from "../assests/SustainabilityImages/suppliers.svg";
import Employee from "../assests/SustainabilityImages/employee.svg";
import image from "../assests/SustainabilityImages/images.svg";
import healthcareImg from "../assests/SustainabilityImages/healthcare.png";
import environmentImg from "../assests/SustainabilityImages/environment.png";
import skillImg from "../assests/SustainabilityImages/skillDevelopment.png";
import communityImg from "../assests/SustainabilityImages/local.png";
import FilePolicy from "../assests/SustainabilityImages/filePolicy.svg";
import Downloads from "../assests/SustainabilityImages/downloads.svg";
import code from "../assests/SustainabilityImages/codeOf.svg";
import responsible from "../assests/SustainabilityImages/responsible.svg";
import supplier from "../assests/SustainabilityImages/supplierCode.svg";
import pharma from "../assests/SustainabilityImages/pharma.svg";
import safety from "../assests/SustainabilityImages/Safety.svg";
import privacy from "../assests/SustainabilityImages/privacy.svg";
import whistleblower from "../assests/SustainabilityImages/whistl.svg";
import leaf from "../assests/SustainabilityImages/leaf.svg";
import big from "../assests/SustainabilityImages/big-Image.png";
import esgReport2425 from '../assests/ESG/Viyash_ESG_report_2025.pdf';
import esgReport2324 from '../assests/ESG/Viyash_ESG_report_2024New (1).pdf';
import esgReport2223 from '../assests/ESG/2022-23-ESG-REPORT (1).pdf';

import brsrReport2425 from '../assests/AnnualReportsPdf/Business Responsibility and Sustainability Report FY 2024-25.pdf';
import brsrReport2324 from '../assests/AnnualReportsPdf/Business Responsibility and Sustainability FY 23-24.pdf';
import brsrReport2223 from '../assests/AnnualReportsPdf/Business Responsibility and Sustainability FY 22-23.pdf';

import businessResponsibilityPolicy from '../assests/SustainabilityImages/PoliciesPdfs/Business Responsibility Policy.pdf';
import codeOfEthicsPolicy from '../assests/SustainabilityImages/PoliciesPdfs/Code of Ethics & Conduct.pdf';
import environmentalPolicy from '../assests/SustainabilityImages/PoliciesPdfs/Environmental policy.pdf';
import pharmaPolicy from '../assests/SustainabilityImages/PoliciesPdfs/Pharmaceutical in the Environment Policy.pdf';
import sshPolicy from '../assests/SustainabilityImages/PoliciesPdfs/Policy of Safety, Security, Health and Environmental Protection.pdf';
import responsibleProcurementPolicy from '../assests/SustainabilityImages/PoliciesPdfs/Responsible Procurment policy.pdf';
import supplierCodePolicy from '../assests/SustainabilityImages/PoliciesPdfs/Supplier Code of Conduct.pdf';
import whistleblowerPolicy from '../assests/SustainabilityImages/PoliciesPdfs/Whistlblower.pdf';




const DownloadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
);

const PolicyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
    </svg>
);

const ArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="12 5 19 12 12 19" />
    </svg>
);


export const socialResponsibilityData = {
    title: "Social Responsibility",
    subtitle:
        "Protecting people, empowering communities, and building a responsible supply chain.",

    mainSection: {
        heading: "Supporting community aspirations",
        description:
            "We believe in fostering inclusive growth and sustainable development. By identifying key areas for focused intervention, we undertake initiatives that drive meaningful and lasting transformation. Our social programmes are designed to support the holistic development of the communities in which we operate.",

        points: [
            "Promoting Health",
            "Supporting Infrastructure Development",
            "Promoting Hygiene",
            "Environment Sustainability",
            "Community Initiatives"
        ]
    },

    cards: [
        {
            icon: Certified,
            label: "Certified",
            themeBg: "#E1F5FE",
            themeColor: "#0288D1",
            title: "ISO 45001 Health & Safety",
            description:
                "Occupational health and safety management system certified across manufacturing sites — systematic risk assessment, incident prevention, and continual improvement."
        },
        {
            icon: Chemical,
            label: "GHS International",
            themeBg: "#F3E5F5",
            themeColor: "#7B1FA2",
            title: "GHS Chemical Management",
            description:
                "International GHS-based chemical classification and hazard communication — ensuring safe handling, storage, and transport of all chemicals used in manufacturing."
        },
        {
            icon: ProcessSafety,
            label: "In-house Lab",
            themeBg: "#FBE9E7",
            themeColor: "#D84315",
            title: "Process Safety Evaluation Lab",
            description:
                "Dedicated in-house Process Safety Evaluation Laboratory — proactive identification and mitigation of chemical process hazards before scale-up."
        },
        {
            icon: Amria,
            label: "AMRIA Certified",
            themeBg: "#E8F5E9",
            themeColor: "#388E3C",
            title: "AMRIA STD Certification",
            description:
                "Antimicrobial Resistance Industry Alliance (AMRIA) Standard certification — demonstrating responsible manufacturing practices in the fight against AMR."
        },
        {
            icon: Suppliers,
            label: "Supply Chain",
            themeBg: "#FFF3E0",
            themeColor: "#E65100",
            title: "Supplier ESG Assessment",
            description:
                "Structured ESG assessment program for key suppliers — ensuring responsible sourcing and propagating sustainability standards throughout the value chain."
        },
        {
            icon: Employee,
            label: "42 hrs / employee",
            themeBg: "#E0F2F1",
            themeColor: "#00796B",
            title: "Employee Development",
            description:
                "Comprehensive talent development programs — 42+ annual training hours per employee, safety culture initiatives, and diversity & inclusion commitments."
        }
    ]
};
const cardsData = [
    {
        tag: "Health",
        title: "Healthcare Outreach",
        color: "rgba(198, 40, 40, 1)",
        backgroundColor: "rgba(255, 235, 238, 1)",
        desc: "Free medical camps, essential medicine distribution, and preventive healthcare programs for underserved communities near our manufacturing sites.",
        image: healthcareImg,
    },
    {
        tag: "Environment",
        title: "Environmental Community Programs",
        color: "rgba(46, 125, 50, 1)",
        backgroundColor: "rgba(232, 245, 233, 1)",
        desc: "Tree plantation drives, watershed conservation, and community-level environmental awareness programs aligned with our zero-waste mission.",
        image: environmentImg,
    },
    {
        tag: "Education",
        title: "Skill Development Initiatives",
        color: "rgba(21, 101, 192, 1)",
        backgroundColor: "rgba(227, 242, 253, 1)",
        desc: "Vocational training, pharmaceutical laboratory skills programs, and industry-relevant education for youth in communities adjacent to our operations.",
        image: skillImg,
    },
    {
        tag: "Community",
        title: "Local Community Engagement",
        color: "rgba(106, 27, 154, 1)",
        backgroundColor: "rgba(243, 231, 248, 1)",
        desc: "Structured engagement with local panchayats, village communities, and NGO partners — addressing identified community needs through multi-year CSR programs.",
        image: communityImg,
    },
];
const policies = [
    {
        title: "Business Responsibility & Sustainability Policy",
        tag: "Core Policy",
        size: "0.6 MB",
        icon: FilePolicy,
        tagBg: "#E3F2FD",
        tagColor: "#1565C0",
        file: businessResponsibilityPolicy
    },
    {
        title: "Code of Ethics & Conduct",
        tag: "Ethics",
        size: "3.2 MB",
        icon: code,
        tagBg: "#F3E5F5",
        tagColor: "#6A1B9A",
        file: codeOfEthicsPolicy
    },
    {
        title: "Environmental Policy",
        tag: "Environmental",
        size: "0.4 MB",
        icon: pharma,
        tagBg: "#E8F5E9",
        tagColor: "#2E7D32",
        file: environmentalPolicy
    },
    {
        title: "Responsible Procurement Policy",
        tag: "Supply Chain",
        size: "0.3 MB",
        icon: responsible,
        tagBg: "#FFF3E0",
        tagColor: "#E65100",
        file: responsibleProcurementPolicy
    },
    {
        title: "Supplier Code of Conduct",
        tag: "Supply Chain",
        size: "1.0 MB",
        icon: supplier,
        tagBg: "#FFF3E0",
        tagColor: "#E65100",
        file: supplierCodePolicy
    },
    {
        title: "Pharmaceutical-in-Environment & AMR Policy",
        tag: "Environmental",
        size: "0.5 MB",
        icon: pharma,
        tagBg: "#E8F5E9",
        tagColor: "#2E7D32",
        file: pharmaPolicy
    },
    {
        title: "Safety, Security, Health & Environmental Policy",
        tag: "SSHE",
        size: "0.7 MB",
        icon: safety,
        tagBg: "#FFEBEE",
        tagColor: "#C62828",
        file: sshPolicy
    },
    {
        title: "Privacy Policy",
        tag: "Data",
        size: "0.5 MB",
        icon: privacy,
        tagBg: "#E0F2F1",
        tagColor: "#00695C",
        isRedirect: true
    },
    {
        title: "Whistleblower & Vigil Mechanism Policy",
        tag: "Ethics",
        size: "0.8 MB",
        icon: whistleblower,
        tagBg: "#F3E5F5",
        tagColor: "#6A1B9A",
        file: whistleblowerPolicy
    },
];



const statsData = [
    { value: 'EcoVadis 59', label: 'Sustainability Score' },
    { value: '2780 KWp', label: 'Solar PV Installed' },
    { value: 'ZLD', label: 'Zero Liquid Discharge' },
    { value: 'SBTi', label: 'Validated Targets' },
    { value: 'GRI Based', label: 'ESG Reporting' },
    { value: 'ISO 14001', label: 'Environment Certified' },
];

const TABS = [
    "ESG Framework",
    "Environment",
    "Social",
    "Governance",
    "CSR",
    "ESG Reports",
    "Roadmap",
    "Downloads",
];

const TAB_TARGETS = [
    "esg-framework",
    "environment",
    "social",
    "governance",
    "community",
    "esg",
    "roadmap",
    "downloads",
];

const ESG_CARDS = [
    {
        id: 'environment',
        title: 'Environmental',
        icon: EnvironmentalIcon,
        points: [
            'ISO 14001 Environmental Management System',
            'Zero Liquid Discharge (ZLD) facilities',
            'Zero Hazardous Waste Landfill Program',
            '2780 KWp Solar PV Installation',
            'SBTi Validated Near-Term & Net-Zero Targets',
            'Comprehensive GHG Accounting — Scope 1, 2 & 3'
        ],
        theme: 'green'
    },
    {
        id: 'social',
        title: 'Social',
        icon: SocialIcon,
        points: [
            'ISO 45001 Occupational Health & Safety',
            'International GHS Chemical Management',
            'Dedicated Process Safety Evaluation Lab',
            'AMRIA STD Antimicrobial Certification',
            'Supplier ESG Assessment Program',
            'Employee Training & Development Initiatives'
        ],
        theme: 'blue'
    },
    {
        id: 'governance',
        title: 'Governance',
        icon: GovernanceIcon,
        points: [
            'Business Responsibility & Sustainability Policy',
            'Code of Ethics & Conduct',
            'Responsible Procurement Policy',
            'Pharmaceutical-in-Environment & AMR Policy',
            'Supplier Code of Conduct',
            'GRI-Aligned ESG reporting'
        ],
        theme: 'navy'
    }
];

const ESG_TAGS = [
    { text: 'GRI Based ESG Reporting', color: '#2E7D32', border: 'rgba(46, 125, 50, 0.19)', bg: '#E8F5E9' },
    { text: 'SBTi Validated Targets', color: '#1565C0', border: 'rgba(21, 101, 192, 0.19)', bg: '#E1F5FE' },
    { text: 'EcoVadis Score 59', color: '#E65100', border: 'rgba(230, 81, 0, 0.19)', bg: '#FFF3E0' },
    { text: 'CDP Disclosure', color: '#4A148C', border: 'rgba(74, 20, 140, 0.19)', bg: '#F3E5F5' },
    { text: 'Manufacture 2030', color: '#00695C', border: 'rgba(0, 105, 92, 0.19)', bg: '#E0F2F1' },
    { text: 'ISO 14001 & ISO 45001', color: '#2E7D32', border: 'rgba(46, 125, 50, 0.19)', bg: '#E8F5E9' }
];

const ENVIRONMENTAL_BANNERS = [
    {
        title: 'Solar PV Installation',
        detail: '2780 KWp across sites',
        image: SolarPVInstallation
    },
    {
        title: 'Zero Liquid Discharge',
        detail: 'Treated water recycling',
        image: ZeroLiquidDischarge
    }
];

const ENVIRONMENTAL_CARDS = [
    {
        title: 'ISO 14001 Environmental Management',
        desc: 'All manufacturing sites certified to ISO 14001 — rigorous environmental management system covering waste, emissions, energy, and continuous improvement.',
        badge: 'All Sites',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M1.66675 16.6666C1.66675 17.1087 1.84234 17.5326 2.1549 17.8451C2.46746 18.1577 2.89139 18.3333 3.33341 18.3333H16.6667C17.1088 18.3333 17.5327 18.1577 17.8453 17.8451C18.1578 17.5326 18.3334 17.1087 18.3334 16.6666V6.66663L12.5001 10.8333V6.66663L6.66675 10.8333V3.33329C6.66675 2.89127 6.49115 2.46734 6.17859 2.15478C5.86603 1.84222 5.44211 1.66663 5.00008 1.66663H3.33341C2.89139 1.66663 2.46746 1.84222 2.1549 2.15478C1.84234 2.46734 1.66675 2.89127 1.66675 3.33329V16.6666Z" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14.1667 15H15.0001" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10 15H10.8333" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.83325 15H6.66659" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    },
    {
        title: 'Zero Liquid Discharge (ZLD)',
        desc: 'ZLD facilities with comprehensive treated water recycling programs — ensuring zero harmful effluent discharge to environment across all applicable units.',
        badge: 'ZLD Certified',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5.83333 13.5833C7.66667 13.5833 9.16667 12.0583 9.16667 10.2083C9.16667 9.24163 8.69167 8.32496 7.74167 7.54996C6.79167 6.77496 6.075 5.62496 5.83333 4.41663C5.59167 5.62496 4.88333 6.78329 3.925 7.54996C2.96667 8.31663 2.5 9.24996 2.5 10.2083C2.5 12.0583 4 13.5833 5.83333 13.5833Z" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.4666 5.50006C11.0398 4.58433 11.446 3.57426 11.6666 2.51672C12.0833 4.60006 13.3333 6.60006 15 7.93339C16.6666 9.26672 17.5 10.8501 17.5 12.5167C17.5047 13.6686 17.1673 14.796 16.5306 15.756C15.8939 16.7159 14.9865 17.4652 13.9234 17.9088C12.8603 18.3524 11.6895 18.4704 10.5593 18.2478C9.42906 18.0252 8.3904 17.472 7.57495 16.6584" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    },
    {
        title: 'Zero Hazardous Waste Landfill',
        desc: 'Company-wide zero hazardous waste to landfill program — all hazardous waste streams are managed through co-processing, incineration, or recycling pathways.',
        badge: 'Zero Landfill',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5.8333 15.8333H4.01247C3.74961 15.8341 3.49101 15.7669 3.26178 15.6382C3.03254 15.5096 2.84045 15.3239 2.70414 15.0991C2.57323 14.8734 2.50401 14.6172 2.50342 14.3562C2.50284 14.0953 2.57091 13.8388 2.7008 13.6125L5.99664 7.91663" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.16675 15.8333H16.0026C16.2642 15.8313 16.5209 15.762 16.7479 15.6321C16.975 15.5022 17.1649 15.3161 17.2992 15.0917C17.4283 14.8666 17.4963 14.6116 17.4963 14.3521C17.4963 14.0926 17.4283 13.8376 17.2992 13.6125L16.2776 11.8458" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.6667 13.3334L9.16675 15.8334L11.6667 18.3334" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.91075 11.33L5.99659 7.91663L2.58325 8.83163" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.78662 4.8425L8.69745 3.26584C8.82825 3.03783 9.01575 2.84751 9.24177 2.71332C9.46779 2.57914 9.72466 2.50566 9.98745 2.5C10.2482 2.49952 10.5046 2.56764 10.7307 2.69752C10.9568 2.82741 11.1448 3.0145 11.2758 3.24L14.5616 8.9425" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.1484 8.02751L14.5618 8.94251L15.4759 5.52917" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    },
    {
        title: '2780 KWp Solar PV Installation',
        desc: 'On-site renewable energy generation through solar photovoltaic systems across multiple sites — progressively increasing renewable energy share in total consumption.',
        badge: '2780 KWp',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10.0001 13.3333C11.841 13.3333 13.3334 11.8409 13.3334 9.99996C13.3334 8.15901 11.841 6.66663 10.0001 6.66663C8.15913 6.66663 6.66675 8.15901 6.66675 9.99996C6.66675 11.8409 8.15913 13.3333 10.0001 13.3333Z" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10 1.66663V3.33329" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10 16.6666V18.3333" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M4.1084 4.10828L5.2834 5.28328" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14.7166 14.7167L15.8916 15.8917" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.66675 10H3.33341" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.6667 10H18.3334" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.2834 14.7167L4.1084 15.8917" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.8916 4.10828L14.7166 5.28328" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    },
    {
        title: 'SBTi Validated Emission Targets',
        desc: 'Science-Based Targets initiative (SBTi) validated near-term and net-zero emission reduction targets — aligned with 1.5°C pathway and Paris Agreement commitments.',
        badge: 'SBTi Validated',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M18.3334 5.83325L11.2501 12.9166L7.08341 8.74992L1.66675 14.1666" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.3333 5.83325H18.3333V10.8333" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    },
    {
        title: 'Comprehensive GHG Accounting',
        desc: 'Full GHG inventory covering Scope 1 (direct), Scope 2 (purchased energy), and Scope 3 (value chain) emissions — reported annually per GHG Protocol standards.',
        badge: 'Scope 1, 2 & 3',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M17.95 12.5H14.1667C13.7246 12.5 13.3007 12.6756 12.9882 12.9882C12.6756 13.3007 12.5 13.7246 12.5 14.1667V17.95" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.83325 2.78345V4.16678C5.83325 4.82982 6.09664 5.46571 6.56549 5.93455C7.03433 6.40339 7.67021 6.66678 8.33325 6.66678C8.77528 6.66678 9.1992 6.84238 9.51176 7.15494C9.82432 7.4675 9.99992 7.89142 9.99992 8.33345C9.99992 9.25011 10.7499 10.0001 11.6666 10.0001C12.1086 10.0001 12.5325 9.82452 12.8451 9.51196C13.1577 9.1994 13.3333 8.77547 13.3333 8.33345C13.3333 7.41678 14.0833 6.66678 14.9999 6.66678H17.6416" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.16658 18.2917V15.0001C9.16658 14.5581 8.99099 14.1341 8.67843 13.8216C8.36587 13.509 7.94195 13.3334 7.49992 13.3334C7.05789 13.3334 6.63397 13.1578 6.32141 12.8453C6.00885 12.5327 5.83325 12.1088 5.83325 11.6667V10.8334C5.83325 10.3914 5.65766 9.96746 5.3451 9.6549C5.03254 9.34234 4.60861 9.16675 4.16659 9.16675H1.70825" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.0001 18.3334C14.6025 18.3334 18.3334 14.6025 18.3334 10.0001C18.3334 5.39771 14.6025 1.66675 10.0001 1.66675C5.39771 1.66675 1.66675 5.39771 1.66675 10.0001C1.66675 14.6025 5.39771 18.3334 10.0001 18.3334Z" stroke="#2E7D32" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    }
];

const NET_ZERO_STATS = [
    //{ value: '18%', label: 'GHG Intensity Reduction vs 2019' },
    { value: '2780 KWp', label: 'Renewable Energy Installed' },
    { value: '100%', label: 'ZLD Compliance' }
];

const Sustainability = () => {
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();

    const { title, subtitle, mainSection, cards } = socialResponsibilityData;


    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <>
            <div className="sus-page-wrapper">
                {/* Hero Section */}
                <section className="sus-hero">
                    <img src={heroBg} alt="Sustainability Background" className="sus-hero-bg" />
                    <div className="sus-hero-overlay" />

                    <div className="sus-hero-inner">
                        <div className="sus-hero-layout">
                            <div className="sus-hero-left">
                                <h1 className="sus-hero-title">
                                    Environmental, Social<br />
                                    &amp; Governance (ESG)
                                </h1>
                                <p className="sus-hero-desc">
                                    Driving Sustainable Growth Through Responsible Science — embedding environmental stewardship,
                                    social equity, and strong governance across Only Indian Operative Boundary.
                                </p>
                                <div className="sus-hero-btns">
                                    <a target="_blank" rel="noopener noreferrer" className="sus-btn-primary" onClick={() => scrollTo('esg-report')}>
                                        <DownloadIcon />
                                        Download ESG Report
                                        <ArrowRight />
                                    </a>

                                    <button className="sus-btn-secondary" onClick={() => scrollTo('governance')}>
                                        <PolicyIcon />
                                        View ESG Policiesa
                                    </button>

                                </div>
                            </div>

                            <div className="sus-hero-right">
                                <img src={vennDiagram} alt="ESG Venn Diagram" className="sus-venn-img" />
                            </div>
                        </div>

                        <div className="sus-stats-bar">
                            {statsData.map((stat, i) => (
                                <div key={i} className="sus-stat-item">
                                    {i > 0 && <div className="sus-stat-divider" />}
                                    <div className="sus-stat-content">
                                        <span className="sus-stat-value">{stat.value}</span>
                                        <span className="sus-stat-label">{stat.label}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Breadcrumb section */}
                <div className="sus-breadcrumb-container">
                    <div className="sus-breadcrumb-wrapper">
                        <a href="/home" className="sus-breadcrumb-link">
                            <svg className="sus-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14"
                                    stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z"
                                    stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Home
                        </a>
                        <span className="sus-breadcrumb-separator">›</span>
                        <span className="sus-breadcrumb-current">Sustainability &amp; CSR</span>
                    </div>
                </div>

                {/* Sticky Navigation Tabs */}
                <div className="sus-tabs-container">
                    <div className="sus-tabs-wrapper">
                        {TABS.map((tab, i) => (
                            <button
                                key={tab}
                                onClick={() => {
                                    setActiveTab(i);
                                    scrollTo(TAB_TARGETS[i]);
                                }}
                                className={`sus-tab-button ${activeTab === i ? 'active' : ''}`}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                {/* ESG Framework Section */}
                <section id="esg-framework" className="sus-framework-section">
                    <div className="sus-section-header">
                        <h2 className="sus-framework-title">Our ESG Framework</h2>

                        <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                        <p className="sus-framework-subtitle">
                            A structured, globally-aligned approach integrating Environmental stewardship,
                            Social responsibility, and Governance excellence into every aspect of our operations.
                        </p>
                    </div>

                    <div className="sus-framework-grid">
                        {ESG_CARDS.map((card) => (
                            <div key={card.id} className={`sus-esg-card card-${card.theme}`}>
                                <div className="sus-card-header">
                                    <div className="sus-card-icon-wrapper">
                                        <img src={card.icon} alt={card.title} className="sus-card-icon" />
                                    </div>
                                    <h3 className="sus-card-title">{card.title}</h3>
                                    <div className="sus-card-accent-line" />
                                </div>
                                <ul className="sus-card-list">
                                    {card.points.map((point, idx) => (
                                        <li key={idx} className="sus-card-point">
                                            <span className={`sus-point-dot dot-${card.theme}`} />
                                            <span className="sus-point-text">{point}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    <div className="sus-framework-footer">
                        <h4 className="sus-footer-label">FRAMEWORKS, CERTIFICATIONS &amp; COMMITMENTS</h4>
                        <div className="sus-footer-tags">
                            {ESG_TAGS.map((tag, idx) => (
                                <div
                                    key={idx}
                                    className="sus-footer-tag"
                                    style={{
                                        color: tag.color,
                                        borderColor: tag.border,
                                        backgroundColor: tag.bg
                                    }}
                                >
                                    <svg className="sus-tag-check" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M10.9005 4.99999C11.1289 6.12064 10.9662 7.28571 10.4395 8.30089C9.91279 9.31608 9.054 10.12 8.00631 10.5787C6.95862 11.0373 5.78536 11.1229 4.6822 10.8212C3.57904 10.5195 2.61265 9.84869 1.94419 8.92071C1.27573 7.99272 0.945611 6.86361 1.00888 5.72169C1.07215 4.57976 1.52499 3.49404 2.29188 2.64558C3.05876 1.79712 4.09334 1.23721 5.22308 1.05922C6.35282 0.881233 7.50944 1.09592 8.50005 1.66749" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.5 5.5L6 7L11 2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {tag.text}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Environmental Stewardship Section */}
                <section id="environment" className="sus-env-section">
                    <div className="sus-section-header">
                        <h2 className="sus-framework-title">Environmental Stewardship</h2>
                        <img src={section2img} alt="Pharma Lab" className="home-section2-image" />

                        <p className="sus-framework-subtitle">
                            Science-led environmental management — from certified zero-discharge
                            facilities to validated science-based climate targets.
                        </p>
                    </div>

                    <div className="sus-env-layout">
                        {/* LEFT Column: Image Banners */}
                        <div className="sus-env-left">
                            {ENVIRONMENTAL_BANNERS.map((banner, i) => (
                                <div key={i} className="sus-env-banner">
                                    <img src={banner.image} alt={banner.title} className="sus-env-banner-img" />
                                    <div className="sus-env-banner-overlay">
                                        <h3 className="sus-env-banner-title">{banner.title}</h3>
                                        <p className="sus-env-banner-detail">{banner.detail}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* RIGHT Column: Grid of Cards */}
                        <div className="sus-env-right">
                            <div className="sus-env-cards-grid">
                                {ENVIRONMENTAL_CARDS.map((card, i) => (
                                    <div key={i} className="sus-env-card">
                                        <div className="sus-env-card-top">
                                            <div className="sus-env-card-icon-box">
                                                {card.icon}
                                            </div>
                                            <span className="sus-env-badge">{card.badge}</span>
                                        </div>
                                        <h3 className="sus-env-card-title">{card.title}</h3>
                                        <p className="sus-env-card-desc">{card.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Bottom Net-Zero Banner */}
                    <div className="sus-net-zero-banner">
                        <img src={CommittedNetZeroBgImage} alt="Net Zero Background" className="sus-net-zero-bg" />
                        <div className="sus-net-zero-overlay" />
                        <div className="sus-net-zero-content">
                            <div className="sus-net-stats-left">
                                <h3 className="sus-net-zero-title">Committed to Net-Zero</h3>
                                <p className="sus-net-zero-desc">
                                    SBTi validated emission reduction targets aligned with the 1.5°C pathway
                                </p>
                            </div>
                            <div className="sus-net-stats-right">
                                {NET_ZERO_STATS.map((stat, i) => (
                                    <div key={i} className="sus-net-stat-box">
                                        <span className="sus-net-stat-value">{stat.value}</span>
                                        <span className="sus-net-stat-label">{stat.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* Placeholder Sections for Scroll Navigation (Remaining) */}
                {/* <div className="sus-content-sections">
                    {TAB_TARGETS.slice(2).map((id, i) => (
                        <section
                            key={id}
                            id={id}
                            className="sus-section-placeholder"
                            style={{
                                height: '600px',
                                padding: '100px 60px',
                                borderBottom: '1px solid #eee',
                                background: i % 2 === 0 ? '#fff' : '#f9f9f9'
                            }}
                        >
                            <h2 style={{ color: '#2E7D32', fontSize: '32px' }}>{TABS[i]}</h2>
                            <p style={{ marginTop: '20px', color: '#666', fontSize: '18px' }}>
                                Content for {TABS[i]} section will be implemented here.
                            </p>
                    ))}
                </div> */}
                <div id='social' className="csr-container">
                    <h1 className="csr-title">{title}</h1>

                    <div className="csr-divider">
                        <span className="line left"></span>
                        <div className="dot"><img src={image} alt="" /></div>
                        <span className="line right"></span>
                    </div>
                    <p className="csr-subtitle">{subtitle}</p>

                    {/* MAIN SECTION */}
                    <div className="csr-main">
                        <div className="csr-image">
                            <div className="overlay">
                                <h3>Safety First Culture</h3>
                                <p>ISO 45001 · GHS · Process Safety Lab</p>
                            </div>
                        </div>

                        <div className="csr-content">
                            <h2>{mainSection.heading}</h2>
                            <p>{mainSection.description}</p>

                            <h4 className="csr-content-heading">Our CSR strategy focuses on:</h4>
                            <ul>
                                {mainSection.points.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* CARDS */}
                    <div className="csr-cards">
                        {cards.map((card, index) => (
                            <div key={index} className="csr-card">
                                <div className="card-top">
                                    <div className="card-icon">
                                        <img src={card.icon} alt={card.title} />
                                    </div>
                                    {card.label && (
                                        <div className="card-label" style={{ backgroundColor: card.themeBg, color: card.themeColor }}>
                                            {card.label}
                                        </div>
                                    )}
                                </div>
                                <h3>{card.title}</h3>
                                <p>{card.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div id='governance' className="cg-container">
                    <div className="cg-wrapper">
                        {/* LEFT SECTION */}
                        <div className="cg-left">
                            <h2 className="cg-title">Corporate Governance</h2>

                            <div className="csr-divider" style={{ justifyContent: "flex-start", gap: "10px" }}>
                                <span className="line left"></span>
                                <div className="dot"><img src={image} alt="" /></div>
                                <span className="line right"></span>
                            </div>

                            <p className="cg-description">
                                Viyash Scientific maintains institutional-grade governance standards —
                                from board composition and committee structure to comprehensive policy
                                frameworks that guide ethical conduct, responsible procurement, and
                                environmental stewardship.
                            </p>

                            {/* IMAGE */}
                            <div className="cg-image">
                                <div className="cg-overlay">
                                    <h4>Institutional Governance Standards</h4>
                                    <p>SEBI BRSR · Independent Board · Full Disclosure</p>
                                </div>
                            </div>

                            {/* STATS */}
                            <div className="cg-stats">
                                <div className="cg-stat">
                                    <h3>SEBI</h3>
                                    <p>GRI-Aligned ESG Reporting</p>
                                </div>

                                <div className="cg-stat">
                                    <h3>50%+</h3>
                                    <p>Independent Directors</p>
                                </div>

                                <div className="cg-stat">
                                    <h3>4+</h3>
                                    <p>Board Committees</p>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SECTION */}
                        <div className="cg-right">
                            <h3 className="cg-policy-title">Policy Library — Downloadable</h3>

                            <div className="cg-policy-list">
                                {policies.map((item, index) => (
                                    item.isRedirect ? (
                                        <div
                                            key={index}
                                            className="cg-policy-card"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => navigate('/policies')}
                                        >
                                            <div className="cg-policy-left">
                                                <div className="cg-icon"><img src={item.icon} alt="policy" /></div>
                                                <div>
                                                    <p className="cg-policy-name">{item.title}</p>
                                                    <span
                                                        className="cg-policy-tag"
                                                        style={{ backgroundColor: item.tagBg, color: item.tagColor }}
                                                    >{item.tag}</span>
                                                    <span className="cg-policy-size">{item.size}</span>
                                                </div>
                                            </div>
                                            <button className="cg-download" style={{ width: "32px", height: "32px", border: "none", background: "none", cursor: "pointer" }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                    <polyline points="12 5 19 12 12 19"></polyline>
                                                </svg>
                                            </button>
                                        </div>
                                    ) : (
                                        <a
                                            key={index}
                                            href={item.file}
                                            target="_blank" rel="noopener noreferrer"
                                            className="cg-policy-card"
                                            style={{ textDecoration: "none" }}
                                        >
                                            <div className="cg-policy-left">
                                                <div className="cg-icon"><img src={item.icon} alt="policy" /></div>
                                                <div>
                                                    <p className="cg-policy-name">{item.title}</p>
                                                    <span
                                                        className="cg-policy-tag"
                                                        style={{ backgroundColor: item.tagBg, color: item.tagColor }}
                                                    >{item.tag}</span>
                                                    <span className="cg-policy-size">{item.size}</span>
                                                </div>
                                            </div>
                                            <button className="cg-download" style={{ width: "32px", height: "32px", border: "none", background: "none", cursor: "pointer" }}>
                                                <img src={Downloads} alt="download" style={{ width: "24px", height: "24px" }} />
                                            </button>

                                        </a>
                                    )
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
                <div id='community' className="ci-container">
                    <h2 className="ci-title">Community Impact</h2>

                    <div className="csr-divider">
                        <span className="line left"></span>
                        <div className="dot"><img src={image} alt="" /></div>
                        <span className="line right"></span>
                    </div>

                    <p className="ci-subtitle">
                        Creating long-term value for communities through targeted healthcare,
                        environmental, and skill development initiatives under our CSR mandate.
                    </p>

                    {/* GREEN STATS BAR */}
                    <div className="ci-stats-bar">
                        <div className="ci-left">
                            <h3>CSR Investment FY 2024–25</h3>
                            <p>Statutory 2% mandate + voluntary contributions across focus areas</p>
                        </div>

                        <div className="ci-right">
                            <div>
                                <h2>₹12 Cr</h2>
                                <p>CSR Spend FY25</p>
                            </div>
                            <div>
                                <h2>4</h2>
                                <p>Focus Areas</p>
                            </div>
                            <div>
                                <h2>25+</h2>
                                <p>Projects Executed</p>
                            </div>
                        </div>
                    </div>

                    {/* CARDS */}
                    <div className="ci-cards">
                        {cardsData.map((item, index) => (
                            <div key={index} className="ci-card">
                                <div
                                    className="ci-image"
                                    style={{ backgroundImage: `url(${item.image})`, backgroundSize: "cover", backgroundPosition: "center" }}
                                >
                                    <span className="ci-tag" style={{ color: item.color, backgroundColor: item.backgroundColor }}>{item.tag}</span>
                                </div>

                                <div className="ci-content">
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div id='esg' className="esg-container">
                    <h1 className="esg-title">ESG Report Archive</h1>

                    <div className="csr-divider">
                        <span className="line left"></span>
                        <div className="dot"><img src={image} alt="" /></div>
                        <span className="line right"></span>
                    </div>

                    <p className="esg-subtitle">
                        Annual GRI-based ESG reports — comprehensive disclosure of our
                        environmental, social, and governance performance.
                    </p>

                    <div className="cards" id="esg-report">
                        {/* Card 1 */}
                        <div className="card">
                            <div className="card-header">
                                <div className="leaf-overlay">
                                    <img src={leaf} alt="leaf" />
                                </div>
                                <span className="badge">Viyash Life Sciences</span>
                                <h2>FY 2024–25</h2>
                                <p className="report-type">ESG Report</p>

                                <div className="tags">
                                    <span>GRI-Based</span>
                                    {/* <span>SBTi Aligned</span> */}
                                </div>
                            </div>

                            <div className="card-body">
                                <p className="report-meta">48 pages · PDF · 4.2 MB</p>
                                <div className="download-btn-group">
                                    <a href={esgReport2425} target="_blank" rel="noopener noreferrer" className="download-btn dual">
                                        <svg width="18" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                        Downlaod PDF
                                    </a>
                                    {/* <a href={brsrReport2425} download="Viyash_BRSR_Report_2024-25.pdf" className="download-btn dual secondary">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                        BRSR
                                    </a> */}

                                </div>
                            </div>



                        </div>

                        {/* Card 2 */}
                        <div className="card">
                            <div className="card-header">

                                <div className="leaf-overlay">
                                    <img src={leaf} alt="leaf" />
                                </div>
                                <h2>FY 2023–24</h2>
                                <p className="report-type">ESG Report</p>

                                <div className="tags">
                                    <span>GRI-Based</span>
                                    {/* <span>SBTi Aligned</span> */}
                                </div>
                            </div>

                            <div className="card-body">
                                <p className="report-meta">44 pages · PDF · 3.9 MB</p>
                                <div className="download-btn-group">
                                    <a href={esgReport2324} target="_blank" rel="noopener noreferrer" className="download-btn">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                        Download PDF
                                    </a>
                                </div>


                            </div>



                        </div>

                        {/* Card 3 */}
                        <div className="card">
                            <div className="card-header">

                                <div className="leaf-overlay">
                                    <img src={leaf} alt="leaf" />
                                </div>
                                <h2>FY 2022–23</h2>
                                <p className="report-type">ESG Report</p>

                                <div className="tags">
                                    <span>GRI-Based</span>
                                    {/* <span>SBTi Aligned</span> */}
                                </div>
                            </div>

                            <div className="card-body">
                                <p className="report-meta">40 pages · PDF · 3.5 MB</p>
                                <div className="download-btn-group">
                                    <a href={esgReport2223} target="_blank" rel="noopener noreferrer" className="download-btn">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                        Download PDF
                                    </a>
                                </div>
                            </div>





                        </div>
                    </div>

                    {/* Bottom Info Box */}
                    <div className="info-box">
                        <div className="info-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                            </svg>
                        </div>
                        <p>
                            Above mentioned <strong>ESG</strong> reports are in accordance with the{" "}
                            <strong>Global Reporting Initiative (GRI) Standards</strong>.
                            These reports have undergone third party
                            assurance exclusively for GHG (Scope-1,2&3) data.


                            {/* All ESG reports are prepared in accordance with the{" "}
                            <strong>Global Reporting Initiative (GRI) Standards</strong> and
                            aligned with <strong>SEBI BRSR</strong> requirements. Reports undergo
                            third-party assurance and include Scope 1, 2 & 3 GHG data, water
                            intensity, waste management, social metrics, and governance disclosures. */}
                        </p>
                    </div>
                </div>
                <div id='roadmap' className="roadmap-container">
                    {/* Title */}
                    <h1 className="title">ESG Roadmap</h1>

                    <div className="csr-divider">
                        <span className="line left"></span>
                        <div className="dot"><img src={image} alt="" /></div>
                        <span className="line right"></span>
                    </div>

                    <p className="subtitle">
                        A decade-long commitment to progressive improvement across Environment,
                        Health & Safety, and Sustainability performance.
                    </p>
                    <img src={big} alt="ESG Roadmap" className="roadmap-image" />
                </div>
                <div id='downloads' className="cta-container">
                    <div className="cta-content">
                        <h1>Our Commitment to a Sustainable Future</h1>

                        <p>
                            For ESG enquiries, sustainability partnerships, or media requests,
                            contact our Sustainability team. We publish annual GRI-based ESG
                            reports and participate in CDP, EcoVadis, and SBTi frameworks.
                        </p>

                        {/* Buttons */}
                        <div className="cta-buttons">
                            <button className="primary-btn">

                                Contact Sustainability Team →
                            </button>

                            <a href={esgReport2425} target="_blank" rel="noopener noreferrer" className="secondary-btn">
                                <DownloadIcon /> Download ESG Report
                            </a>

                        </div>

                        {/* Stats */}
                        <div className="cta-stats">
                            <div>
                                <h3>EcoVadis 59</h3>
                                <span>Sustainability Score</span>
                            </div>

                            <div>
                                <h3>SBTi</h3>
                                <span>Validated Targets</span>
                            </div>

                            <div>
                                <h3>ISO 14001</h3>
                                <span>Environment</span>
                            </div>

                            <div>
                                <h3>ISO 45001</h3>
                                <span>Health & Safety</span>
                            </div>

                            <div>
                                <h3>GRI-Based</h3>
                                <span>ESG Reporting</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sustainability;